import React, { Component } from 'react'
import Responsive from '../Responsive'

export default class BoxListView extends Component {
    state = {
        titles: [
            {
                title: 'Breakfast', items: [
                    { img: '/images/earlybird.jpg', name: 'Early Bird', des: 'egg, toast, tomato, cinemine', price: '$15' },
                    { img: '/images/cereal.jpg', name: 'Cereal', des: 'egg, toast, tomato, cinemine', price: '$10' },
                    { img: '/images/pancake.jpg', name: 'Pancake', des: 'egg, toast, tomato, cinemine', price: '$18' },
                ]
            },
            {
                title: 'Breakfast', items: [
                    { img: '/images/earlybird.jpg', name: 'Early Bird', des: 'egg, toast, tomato, cinemine', price: '$15' },
                    { img: '/images/cereal.jpg', name: 'Cereal', des: 'egg, toast, tomato, cinemine', price: '$10' },
                    { img: '/images/pancake.jpg', name: 'Pancake', des: 'egg, toast, tomato, cinemine', price: '$18' },
                ]
            },
            {
                title: 'Breakfast', items: [
                    { img: '/images/earlybird.jpg', name: 'Early Bird', des: 'egg, toast, tomato, cinemine', price: '$15' },
                    { img: '/images/cereal.jpg', name: 'Cereal', des: 'egg, toast, tomato, cinemine', price: '$10' },
                    { img: '/images/pancake.jpg', name: 'Pancake', des: 'egg, toast, tomato, cinemine', price: '$18' },
                ]
            },
        ]
    }
    render() {
        return (
            <div className='h-100 w-100'>
                <div className='p-3 w-100'>
                    {this.state.titles.map((prop, index) => {
                        return (
                            <div className='w-100 mt-3 bb-gray2'>
                                <button className='text-start' >
                                    <p className='font-size-16 main-c4 weight-600'>{prop.title}</p>
                                </button>
                                <div className='w-100'>
                                    {prop.items.map((item, index) => {
                                        return (
                                            <div className='w-100 pb-3 mb-3 bb-gray'>
                                                <div className='w-100' style={{ overflow: 'hidden', }}>
                                                    <div className='flexcb w-100'>
                                                        <div className='d-flex flex-column'>
                                                            <p className='font-size-16 main-c3 weight-500'>{item.name}</p>
                                                            <p className='font-size-12 main-c7'>{item.des}</p>
                                                        </div>
                                                        <img className='br-8 d-flex' style={{ width: '90px', aspectRatio: '1 / 1', objectFit: 'cover' }} src={item.img} />
                                                    </div>
                                                    <div className='flexcb mt-2'>
                                                        <div>
                                                            <div className='flexc'>
                                                                <p className='blue-bg white font-size-10 br-5' style={{ paddingTop: '3px', paddingBottom:'2px', paddingRight:'5px', paddingLeft:'5px'  }}>%40</p>
                                                                <p className='font-size-11   main-c7 mld-3' style={{ textDecoration: 'line-through gray' }}>$25</p>
                                                            </div>
                                                            <p className='font-size-16 main-c3 weight-500 mt-1' style={{ lineHeight: '100%' }}>{item.price}</p>
                                                        </div>
                                                        <button className='blue-btn-border br-30 py-2' style={{ width: '90px' }}>
                                                            <p className='font-size-10'>Add to Cart</p>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                        )
                                    })}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }
}
